import React, { useState, useEffect } from 'react';
import * as style from "./style.module.css";

const Slideshow = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // スライドを切り替えるタイマー設定
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // 4秒ごとにスライドを切り替え
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className={style.slideshowContainer}>
      {images.map((image, index) => (
        <div
          key={index}
          className={`${style.slide} ${
            index === currentIndex ? style.active : ""
          }`}
        >
          <img src={image} alt={`Slide ${index}`} className={style.image} />
        </div>
      ))}
    </div>
  );
};

export default Slideshow;
